import axios from 'axios';
import store from '../store'
const endpoint = '/api/krainaabc/subprofile/list?device=www';

export function getSubProfilesList() {
    return axios
        .get(endpoint)
        .then((response) => {
            if (response.status === 200) {
                if(response.data && response.data.data) {
                    store.dispatch("setSubProfiles", response.data.data);   
                    return response.data.data;
                } 
                return null;
            }
            return null;
        })
        .catch(() => {
            return null;
        });          
}
